/**
 * Where each service is registered under a version, as its stack registers it.
 *
 * These live in code rather than in the environments because they are a
 * property of the service, not of the deployment: every stack passes the same
 * `BasePath` in every environment's parameters - `parse` for the server,
 * `files` for visualizations, nothing for the rest - and the segment after it is
 * written into the template itself. What actually varies between deployments is
 * the version each one is mapped at, and that is all an environment states.
 *
 * The empty path is the mapping at the version root, which is what makes it the
 * one that answers for every route no longer mapping claims.
 */
export const API_SERVICES = {
  /** The api stack: `assets`, `sample`, `support-files`, `export`, `ai`, and files other than the two below. */
  api: '',
  /** The server stack: Parse. */
  server: 'parse',
  /** Visualizations, DZI half: an asset's tile pyramid, its info and its thumbnail. */
  pyramids: 'files/pyramids',
  /** Visualizations, video half. The same stack as {@link API_SERVICES.pyramids}, and a mapping of its own. */
  videos: 'files/videos',
  mosaics: 'mosaics',
} as const;

/**
 * A service this client addresses.
 *
 * Closed rather than open-ended: a typo in a lookup and an environment naming a
 * service that does not exist are both compile errors.
 */
export type ApiService = keyof typeof API_SERVICES;
